import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { hrApi } from '../../api/hr.js';

export default function MyProfile() {
  const [id, setId] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    hrApi
      .getMyEmployee()
      .then((d) => setId(d?.employee?.id))
      .catch((e) => setError(e.response?.data?.message || 'No employee record linked'));
  }, []);

  if (error) return <div className="alert error">{error}</div>;
  if (!id) return <div className="muted">Loading…</div>;
  return <NavigateInline id={id} />;
}

// Reuse EmployeeProfile with the resolved id by injecting params via Navigate.
// Simpler than mocking useParams.
function NavigateInline({ id }) {
  return <Navigate to={`/hr/employees/${id}`} replace />;
}
